<!-- search bar with term and field filters -->
<div class="filters-search-bar"> 
  <div class="filters-search-bar-main">
    <div class="filter-fields" *ngFor="let filter of filters">
      <app-helpers-search-bar-fields-status
        *ngIf="filter.key == 'status'"
        [filter]="filter"
        (remove)="onRemove($event)"
      ></app-helpers-search-bar-fields-status>
      <app-helpers-search-bar-fields-label
        *ngIf="filter.key == 'label'"
        [filter]="filter"
        (remove)="onRemove($event)"
      ></app-helpers-search-bar-fields-label>
      <app-helpers-search-bar-fields-user
        *ngIf="filter.key == 'user' || filter.key == 'user_owner' || filter.key == 'user_assigned' || filter.key == 'feedback_requestor' || filter.key == 'feedback_user' "
        [filter]="filter"
        (remove)="onRemove($event)"
      ></app-helpers-search-bar-fields-user>
      <app-helpers-search-bar-fields-logbook-event
        *ngIf="filter.key == 'event'"
        [filter]="filter"
        (remove)="onRemove($event)"
      ></app-helpers-search-bar-fields-logbook-event>
    </div>
    <input type="text"  [placeholder]="placeholder" [ngModel]="term"  (ngModelChange)="onTermChanges($event)"/>
  </div>
</div >
